import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import Login from '@bibliocommons/login';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import AuthActions from '../actions/AuthActions';

function select(state) {
  return { auth: state.get('auth') };
}

export class LoginContainer extends BcReactComponent {
  render() {
    const { dispatch, auth } = this.props;
    return (<Login
      auth={auth}
      authActions={bindActionCreators(AuthActions, dispatch)} />);
  }
}

LoginContainer.propTypes = {
  auth: ImmutablePropTypes.mapContains({
    userInfo: ImmutablePropTypes.map
  }),
  dispatch: React.PropTypes.func.isRequired
};

export default connect(select)(LoginContainer);



// WEBPACK FOOTER //
// ./app/containers/LoginContainer.jsx